import { render } from "./IdCheckReview.vue?vue&type=template&id=74735b88&scoped=true"
import script from "./IdCheckReview.vue?vue&type=script&lang=js"
export * from "./IdCheckReview.vue?vue&type=script&lang=js"

import "./IdCheckReview.vue?vue&type=style&index=0&id=74735b88&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74735b88"]])

export default __exports__